/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MemberPreview
 */
export interface MemberPreview {
    /**
     * 
     * @type {number}
     * @memberof MemberPreview
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof MemberPreview
     */
    avatar: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberPreview
     */
    email: string | null;
}

export function MemberPreviewFromJSON(json: any): MemberPreview {
    return MemberPreviewFromJSONTyped(json, false);
}

export function MemberPreviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): MemberPreview {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'avatar': json['avatar'],
        'email': json['email'],
    };
}

export function MemberPreviewToJSON(value?: MemberPreview | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'avatar': value.avatar,
        'email': value.email,
    };
}


